
import Promise from "plugins/bluebird"
import {
  requestIdleCallback,
  RequestIdleCallbackPayload,
} from "plugins/request-animation-frame-polyfill"

const onLoad = () => {
  function init_button_on_load(deadline: RequestIdleCallbackPayload) {
    Promise.resolve(
      import("./button/index")
    )
    .then(({default: button}) => {
      const more_work_required = button.onLoad(deadline)
      if (more_work_required) {
        requestIdleCallback(init_button_on_load)
      }
    })
  }

  requestIdleCallback(init_button_on_load)
}

export default {onLoad}
